import { useEffect } from 'react';

function Torneios() {
  useEffect(() => {
    window.location.href = 'https://arenai.com.br/torneios-publicos';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0a0a0a' }}>
      <p className="text-zinc-500 text-sm">Redirecionando para torneios...</p>
    </div>
  );
}

export default Torneios;
